import React from 'react';
import PropTypes from 'prop-types';

import UserAvatar from 'dpl/path_to_payment/components/UserAvatar';
import { isGreaterThanBreakpoint } from 'dpl/util/grid';

export const SECTION_CLASSES = 'min-h-100 flex justify-center items-center';
const IS_GT_MD = isGreaterThanBreakpoint('md');

export default function BuyerApplicationCustomIntro({
  onNextClick,
  breederProfile
}) {
  const { first_name: breederFirstName } = breederProfile;

  return (
    <div className="flex justify-center items-center min-h-100">
      <div className="FullPageQuizQuestion tc">
        <div className="mb8 flex justify-center">
          <UserAvatar
            size="lg"
            user={{ ...breederProfile, id: breederProfile.user_id }}
          />
        </div>
        <h3 className="f4 f6-md lh-title mb4">
          A few final questions from {breederFirstName}.
        </h3>
        <p className="secondary font-16-mobile mb14">
          {breederFirstName} cares about getting to know you. No right or wrong
          answers — your responses just help build a strong relationship with
          your breeder.
        </p>
        {IS_GT_MD && (
          <button
            type="button"
            onClick={onNextClick}
            className="flex pv3 mt4 mb2 w-100 inline-flex justify-center button fw-medium items-center center nowrap bg-royal-blue white b--royal-blue font-16 br2"
          >
            Continue
          </button>
        )}
      </div>
    </div>
  );
}

BuyerApplicationCustomIntro.propTypes = {
  onNextClick: PropTypes.func.isRequired,
  breederProfile: PropTypes.shape({
    first_name: PropTypes.string,
    user_id: PropTypes.number,
    initials: PropTypes.string,
    profile_photo_url: PropTypes.string
  }).isRequired
};
